const state = {
  infos: [],
  authenticated: false,
  userInfo: {
    token: undefined,
    login: undefined,
    orgId: undefined,
    features: [],
  },
};
export default state;



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js